export default __webpack_public_path__ + "6e30d82301549ca6021e4b6ea4ebf72c.jpg";